import { render, staticRenderFns } from "./HistoricalFilters.vue?vue&type=template&id=dbccbc6a"
import script from "./HistoricalFilters.vue?vue&type=script&lang=js"
export * from "./HistoricalFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports